var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 21.001H6.74805L17.808 9.94103L14.058 6.19104L2.99805 17.251V21.001ZM4.99805 18.081L14.058 9.02104L14.978 9.94103L5.91805 19.001H4.99805V18.081Z",
    fill: "#00467F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.368 3.29104C17.978 2.90104 17.348 2.90104 16.958 3.29104L15.128 5.12104L18.878 8.87104L20.708 7.04104C21.098 6.65104 21.098 6.02104 20.708 5.63104L18.368 3.29104Z",
    fill: "#00467F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeEdit);
export default __webpack_public_path__ + "static/media/mode_edit.fc8c5bb9d4e0356fb0f819c64d117496.svg";
export { ForwardRef as ReactComponent };